<template>
    <div class="app-container">
      <el-row class="headTop">
        <el-col :span="2" :offset="22">
          <el-button style="width:100%"   type="success" icon="el-icon-circle-plus-outline" @click="showDialog()">新增</el-button>
        </el-col>
      </el-row>
    <el-dialog title="数据源配置" :visible.sync="dialogVisible" width="30%">
        <el-form :model="formparams" :rules="rules" ref="formparams" label-width="120px">
            <el-form-item label="公司名称" prop="clubName">
              <el-input v-model="formparams.clubName"></el-input>
            </el-form-item>
            <el-form-item label="数据库库ip" prop="ip">
              <el-input v-model="formparams.ip"></el-input>
            </el-form-item>
            <el-form-item label="数据库端口" prop="port">
              <el-input v-model="formparams.port"></el-input>
            </el-form-item>
            <el-form-item label="数据库名" prop="dataBaseName">
              <el-input v-model="formparams.dataBaseName"></el-input>
            </el-form-item>
            <el-form-item label="数据库用户名" prop="userName">
              <el-input v-model="formparams.userName"></el-input>
            </el-form-item>
            <el-form-item label="数据库密码" prop="password">
              <el-input v-model="formparams.password"></el-input>
            </el-form-item>
            <el-form-item label="是否可配置" prop="typeStatus">
              <el-switch
                v-model="formparams.typeStatus"
                active-value="1"
                inactive-value="0"
                active-color="#13ce66"
                inactive-color="#ccc">
              </el-switch>
            </el-form-item>
           
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button style="width:100px"  @click="resetForm('formparams')">取 消</el-button>
            <el-button style="width:100px"  type="primary" :disabled="showDisabled" @click="submitForm('formparams')">确 定</el-button>
        </span>
    </el-dialog>
    <el-row class="tableList">
      <el-table v-loading="loading" :data="tableData" height="73vh" border stripe>
        <el-table-column
          label="序号"
          type="index"
          width="50">
        </el-table-column>
        <el-table-column prop="clubName" label="公司名称"></el-table-column>
        <el-table-column prop="ip" label="数据库ip"></el-table-column>
        <el-table-column prop="port" label="数据库端口"></el-table-column>
        <el-table-column prop="dataBaseName" label="数据库名"></el-table-column>
        <el-table-column width="400" label="操作">
          <template slot-scope="scope">
            <el-button style="width:100px"  type="primary" @click="edit(scope.row)">编辑</el-button>
            <el-button style="width:100px"  type="primary" @click="payset(scope.row)">支付设置</el-button>
            <el-button style="width:100px"  type="warning" @click="setConfig(scope.row)">配置功能</el-button>
            <!-- <el-button style="width:100px"  type="danger" @click="removeList(scope.row.id)">删除</el-button> -->
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <el-row class="pageination">
      <el-col>
        <el-pagination
          style="textAlign:center;marginTop:10px"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage"
          :page-sizes="[20, 40, 80, 100]"
          :page-size="20"
          layout="total, sizes, prev, pager, next, jumper"
          :total="this.total"
        ></el-pagination>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { getDataSource, addDataSource, updateDataSource} from "../../api/configApi";
import mainHead from "../../components/mainHead/mainHead";
export default {
  data() {
    return {
      loading: true,
      dialogVisible: false,
      query:{
        clubName:''
      },
      addType:1,
      showDisabled:false,
      formparams:{
          clubName:'',//公司名称
          ip:'',//数据库ip
          port:'',//端口
          dataBaseName:'',//数据库名
          userName:'',//数据库用户名
          password:'',//数据库密码
          typeStatus:"1"
      },
      //表单校验
      rules:{
        clubName:[
          { required: true, message: '请输入公司名称', trigger: 'blur' },
          { min: 3, max: 10, message: '长度在 3 到 10 个字符', trigger: 'blur' }
        ],
        ip:[
          { required: true, message:'请输入数据库IP地址', trigger:'blur' }
        ],
        port:[
          { required: true, message:'请输入端口号', trigger:'blur' }
        ],
        dataBaseName:[
          { required: true, message: '请输入数据库名称', trigger: 'blur' }
        ],
        userName:[
          { required: true, message: '请输入数据库用户名', trigger: 'blur' }
        ],
        password:[
          { required: true, message: '请输入数据库密码', trigger: 'blur' }
        ]
      },
      //数据源列表
      tableData:[
      ],
      total: 0,
      currentPage: 1,
      params: {
        page: 1,
        size: 20
      }
    }
  },
  components: {
    mainHead
  },
  mounted() {
    this.getTableList()
  },
  methods: {
    setConfig(row){
      this.$router.push({path:'/rootConfig',query:{clubMemberCode:row.clubMemberCode}})
    },
    showDialog(){
      this.dialogVisible =true
      this.addType = 1
      this.formparams.typeStatus = "1"
      this.formparams.clubName= ''
      this.formparams.ip='',//数据库ip
      this.formparams.port='',//端口
      this.formparams.dataBaseName='',//数据库名
      this.formparams.userName='',//数据库用户名
      this.formparams.password=''//数据库密码
    },
    getTableList(){
      getDataSource().then((res)=>{
        if(res.msg=='success'){
          this.tableData = res.data          
        } else {
          this.$error.message(res.data)
        }
        this.loading = false
      })
    },
    //提交增加数据源接口
    // addDataSource
    submitForm(formparams) {
      this.$refs[formparams].validate((valid) => {
        if (valid) {
          if(this.addType == 1){
            this.formparams.clubName = this.formparams.clubName.replace(/\s*/g,"")
            this.formparams.ip = this.formparams.ip.replace(/\s*/g,"")
            this.formparams.port = this.formparams.port.replace(/\s*/g,"")
            this.formparams.dataBaseName =this.formparams.dataBaseName.replace(/\s*/g,"")
            this.formparams.userName = this.formparams.userName.replace(/\s*/g,"")
            this.formparams.password = this.formparams.password.replace(/\s*/g,"")
            this.showDisabled = true
            addDataSource(this.formparams).then((res)=>{
              if (res.msg == 'success') {
                this.$message({
                  message: '添加成功',
                  type: "success"
                });
                this.showDisabled = false
                this.getTableList();
              } else {
                this.$message({
                  message:res.data,
                  type:'error'
                });
                this.showDisabled = false
              }
              this.dialogVisible = false;
            })
          } else{
            updateDataSource(this.formparams).then((res)=>{
              if (res.msg == 'success') {
                this.$message({
                  message: '修改成',
                  type: "success"
                });
                this.getTableList();
                this.showDisabled = false
              } else {
                this.$message({
                  message:res.data,
                  type:'error'
                });
                this.showDisabled = false
              }
              this.dialogVisible = false;
            })
          }
        } else {
          return false;
        }
      });
    },
    resetForm(formparams) {
      this.dialogVisible = false;
      this.$refs[formparams].clearValidate();
    },
    edit(row){
      this.addType = 2
      this.dialogVisible= true
      console.log(row)
      this.formparams.id = row.id
      this.formparams.ip = row.ip
      this.formparams.clubName = row.clubName
      this.formparams.port = row.port
      this.formparams.dataBaseName = row.dataBaseName
      this.formparams.typeStatus = row.typestatus.toString()
    },
    payset(row){
      this.$router.push({name:'paySet',query:{clubMemberCode:row.clubMemberCode}})
      console.log(row)
    },
    removeList(id){
      this.$message.error('暂未开发')
    },
      //分页
    handleSizeChange(val) {
      this.params.size = val;
      this.params.page = 1;
      this.currentPage = 1;
    },
    handleCurrentChange(val) {
      this.params.page = val;
    },
  }
};
</script>
<style scoped lang="scss">
.app-container {
  position: relative;
  height: auto;
  // .headTop {
  //   background: #ffffff;
  //   padding: 20px;
  // }
}
</style>


// WEBPACK FOOTER //
// dataSource.vue?339fe8c6